<script setup>
import { computed, ref } from 'vue';
import { asset } from '../../helpers.js';

const props = defineProps({
    minOrderValue: { type: Number, required: true },
    landingPage: { type: Boolean, default: true, required: false }
});

// TODO: Trikot-/WM-Grafiken final hinterlegen (Platzhalter: trikot.png).
const imgTrikot = asset('/hkcm/images/trikot.png', 'public');

// TODO: Echten WM-Aktionscode eintragen (analog GLUECK20 beim Glücksrad).
const RAFFLE_CODE = 'WM-CODE';

const copied = ref(false);

function copyCode() {
    navigator.clipboard.writeText(RAFFLE_CODE).then(() => {
        copied.value = true;
        setTimeout(() => { copied.value = false; }, 2000);
    });
}

const expandedSofort = ref(new Set());
const toggleSofort = (title) => {
    expandedSofort.value.has(title) ? expandedSofort.value.delete(title) : expandedSofort.value.add(title);
    expandedSofort.value = new Set(expandedSofort.value);
};

function formatOrderValue(value) {
    return Math.round(value).toLocaleString('de-DE');
}

// TODO: Echte WM-Sofortgewinne (Bild/Titel/Beschreibung) eintragen.
const sofortgewinne = [
    { img: imgTrikot, title: 'Sofortgewinn 1 (Platzhalter)', desc: 'TODO: Beschreibung des WM-Sofortgewinns.' },
    { img: imgTrikot, title: 'Sofortgewinn 2 (Platzhalter)', desc: 'TODO: Beschreibung des WM-Sofortgewinns.' },
    { img: imgTrikot, title: 'Sofortgewinn 3 (Platzhalter)', desc: 'TODO: Beschreibung des WM-Sofortgewinns.' }
];

// TODO: Echte WM-Hauptpreise (Bild/Titel/Beschreibung) eintragen.
const hauptpreise = [
    { img: imgTrikot, title: 'Hauptpreis 1 (Platzhalter)', desc: 'TODO: Beschreibung des WM-Hauptpreises.' },
    { img: imgTrikot, title: 'Hauptpreis 2 (Platzhalter)', desc: 'TODO: Beschreibung des WM-Hauptpreises.' },
    { img: imgTrikot, title: 'Hauptpreis 3 (Platzhalter)', desc: 'TODO: Beschreibung des WM-Hauptpreises.' }
];

const steps = computed(() => [
    {
        title: `Für min. ${formatOrderValue(props.minOrderValue)} € einkaufen`,
        subtitle: `Legen Sie HKCM-Produkte im Wert von mindestens ${formatOrderValue(props.minOrderValue)} € in den Warenkorb und schließen Sie die Bestellung ab.`,
        icon: 'cart',
        highlight: true
    },
    {
        // TODO: WM-Teilnahme-Mechanik final beschreiben.
        title: 'Am Gewinnspiel teilnehmen',
        subtitle: 'TODO: Mechanik der WM-Aktion beschreiben (z.B. automatische Teilnahme nach dem Checkout).',
        icon: 'ticket',
        highlight: !props.landingPage
    },
    {
        title: 'Sofort gewinnen',
        subtitle: 'TODO: Beschreibung des Sofortgewinns bei der WM-Aktion.',
        icon: 'trophy',
        highlight: false
    },
    {
        title: 'Hauptpreis-Auslosung',
        subtitle: 'Am Ende des Aktionszeitraums werden die Gewinner der Hauptpreise ausgelost und verkündet.',
        icon: 'ticket',
        highlight: false
    }
]);
</script>

<template>
    <div class="w-full">
        <!-- Rabatt-Banner -->
        <!-- TODO: Prüfen, ob die WM-Aktion einen Zusatzrabatt-Code hat. Falls nein, diesen Banner entfernen. -->
        <div
            class="relative rounded-xl mx-1 sm:mx-0 mb-10 sm:mb-14 flex flex-row items-stretch w-full overflow-visible"
            style="background: rgba(8, 18, 55, 0.82); border: 1px solid rgba(255, 255, 255, 0.25)"
        >
            <div class="flex flex-col justify-center gap-3 py-5 px-5 flex-1 min-w-0">
                <p style="font-family: 'Montserrat', sans-serif; font-weight: 700; font-size: 18px; line-height: 130%; color: #dcc149">
                    <!-- TODO: WM-Rabatttext -->
                    Exklusiver Zusatzrabatt mit dem Code: <span style="white-space: nowrap">{{ RAFFLE_CODE }}</span>
                </p>
                <p style="font-family: 'Montserrat', sans-serif; font-weight: 400; font-size: 17px; line-height: 150%; color: #fff">
                    <!-- TODO: WM-Rabattbeschreibung + Aktionszeitraum -->
                    Während des Aktionszeitraums erhalten alle Käufer einen Zusatzrabatt auf das gesamte HKCM-Sortiment.<br />
                    Der Rabatt gilt ausschließlich bei Eingabe des Rabatt-Codes
                    <button
                        class="group inline-flex items-center gap-1.5 px-2 py-0.5 rounded-lg transition-all duration-200 hover:scale-[1.01] active:scale-95 align-middle"
                        style="background: rgba(220, 193, 73, 0.15); border: 1px solid rgba(220, 193, 73, 0.5); box-shadow: 0 2px 8px rgba(220, 193, 73, 0.15)"
                        @click="copyCode"
                    >
                        <span style="font-family: 'Montserrat', sans-serif; font-weight: 800; font-size: 16px; color: #dcc149; letter-spacing: 2px">{{ RAFFLE_CODE }}</span>
                        <svg v-if="!copied" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#DCC149" viewBox="0 0 256 256" class="opacity-80 group-hover:opacity-100 transition-opacity">
                            <path d="M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z"></path>
                        </svg>
                        <span v-else style="font-size: 11px; color: #4ade80; font-weight: 600">✓</span>
                    </button>
                    im Checkout. <!-- TODO: Aktionszeitraum der WM-Aktion eintragen. -->
                </p>
            </div>

            <img
                :src="imgTrikot"
                alt=""
                aria-hidden="true"
                class="absolute right-3 object-contain pointer-events-none hidden sm:block rotate-[-3deg]"
                style="width: 160px; height: auto; bottom: -10px; filter: drop-shadow(10px 14px 14px rgba(0, 0, 0, 0.35))"
            />
        </div>

        <!-- Preise -->
        <section
            class="flex flex-col 2xl:flex-row items-start justify-center 2xl:justify-between gap-8 sm:gap-12 overflow-visible"
            :class="props.landingPage ? 'mt-10 sm:mt-14' : 'mt-0'"
        >
            <!-- Sofortgewinne (BLAU) -->
            <div class="flex flex-col items-stretch gap-4 w-full 2xl:w-1/2 2xl:min-w-0">
                <div v-if="props.landingPage" class="hidden 2xl:flex h-[300px] items-center justify-center">
                    <!-- TODO: WM-Titelgrafik (Platzhalter: Trikot). -->
                    <img :src="imgTrikot" alt="Gewinnspiel zur WM Aktion 26" class="w-auto max-w-[260px] object-contain" />
                </div>
                <div class="w-full rounded-3xl p-[2px] bg-gradient-to-br from-blue-400/90 via-blue-500/70 to-indigo-700 shadow-[0_20px_60px_rgba(0,0,0,.35)]">
                    <div class="rounded-[22px] bg-[#0a1325] p-3 sm:p-6">
                        <div class="flex flex-col gap-3 sm:gap-4">
                            <h3
                                class="mb-0 font-semibold"
                                style="font-family: 'Montserrat', sans-serif; font-size: 26px; line-height: 32px; letter-spacing: -0.576px; color: #007fff"
                            >
                                Sofortgewinne
                            </h3>
                            <p class="mb-0 font-semibold text-white" style="font-family: 'Montserrat', sans-serif; font-size: 19px; line-height: 140%">
                                Ein Sofortgewinn – direkt nach der Teilnahme
                            </p>
                        </div>

                        <div class="mt-4 sm:mt-6 flex flex-col gap-2">
                            <div
                                v-for="prize in sofortgewinne"
                                :key="prize.title"
                                class="prize-card relative overflow-hidden flex flex-col sm:flex-row sm:items-center gap-0 sm:gap-5 rounded-xl bg-white/[0.06] border border-white/20 transition-all duration-200 transform-gpu hover:scale-[1.01] hover:brightness-110 w-full max-w-full 2xl:max-w-[600px] sm:pl-2"
                            >
                                <span class="sofort-ribbon">SOFORT</span>
                                <img
                                    :src="prize.img"
                                    :alt="prize.title"
                                    class="prize-img self-center object-contain sm:shrink-0 px-4 pt-3 sm:p-0 h-[120px] sm:self-auto sm:w-[140px] sm:h-[140px]"
                                />
                                <div class="flex-1 min-w-0 px-3 sm:px-0 pb-3 sm:py-2.5 sm:mr-8 flex flex-col gap-2">
                                    <button
                                        class="w-full flex items-center justify-between gap-2 sm:cursor-default transition-transform duration-200 hover:scale-[1.01]"
                                        @click="toggleSofort(prize.title)"
                                    >
                                        <p class="font-semibold text-white text-sm leading-tight text-left sm:pr-32" style="hyphens: none">{{ prize.title }}</p>
                                        <svg
                                            class="sm:hidden shrink-0 transition-transform duration-200 text-white/60"
                                            :class="expandedSofort.has(prize.title) ? 'rotate-180' : ''"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                        >
                                            <path d="M2 5l6 6 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </button>
                                    <p class="text-xs text-white/90 leading-relaxed hidden sm:block">{{ prize.desc }}</p>
                                    <p v-if="expandedSofort.has(prize.title)" class="text-xs text-white/90 leading-relaxed sm:hidden">{{ prize.desc }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Hauptpreise (GOLD) -->
            <div class="flex flex-col items-stretch gap-4 w-full 2xl:w-1/2 2xl:min-w-0">
                <div v-if="props.landingPage" class="hidden 2xl:flex h-[320px] items-center justify-center overflow-visible -mt-6">
                    <!-- TODO: WM-Preispräsentation (Platzhalter: Trikot). -->
                    <img :src="imgTrikot" alt="WM-Hauptpreise" class="hero-img w-auto max-w-[360px] object-contain relative z-20" style="padding: 8px 16px 0 16px" />
                </div>
                <div class="w-full flex-1 rounded-[20px] p-3 sm:p-6 flex flex-col gap-0 relative" style="background: rgba(220, 193, 73, 0.3)">
                    <div class="flex flex-col gap-3 sm:gap-4">
                        <h3 class="text-yellow-300 mb-0 font-semibold" style="font-family: 'Montserrat', sans-serif; font-size: 26px; line-height: 32px; letter-spacing: -0.576px">
                            Hauptpreise
                        </h3>
                        <p class="mb-0 font-semibold text-white" style="font-family: 'Montserrat', sans-serif; font-size: 19px; line-height: 140%">Auslosung am Aktionsende</p>
                    </div>

                    <div class="mt-4 sm:mt-6 flex flex-col gap-2">
                        <div
                            v-for="prize in hauptpreise"
                            :key="prize.title"
                            class="hauptpreis-card relative overflow-hidden flex flex-row rounded-xl w-full max-w-full 2xl:max-w-[600px] transition-all duration-200 transform-gpu hover:scale-[1.01] hover:brightness-110"
                            style="background: rgba(255, 255, 255, 0.1); border: 1px solid rgba(255, 255, 255, 0.2)"
                        >
                            <span class="auslosung-ribbon">AUSLOSUNG</span>
                            <div
                                v-if="prize.img"
                                class="w-[120px] sm:w-[140px] xl:w-[150px] h-auto shrink-0 overflow-hidden bg-[#10203b]"
                                style="filter: drop-shadow(0px 0px 30px #dcc149)"
                            >
                                <img :src="prize.img" :alt="prize.title" class="w-full h-full object-cover object-center" />
                            </div>
                            <div class="flex flex-col justify-center gap-2 py-5 px-5 flex-1 min-w-0">
                                <p class="font-semibold text-white text-sm leading-tight text-left pr-32">{{ prize.title }}</p>
                                <p class="mt-1 text-xs text-white/90 leading-relaxed">{{ prize.desc }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- So funktioniert's -->
        <section id="hkcm-wmaktion-so-funktioniert" class="relative mt-16 sm:mt-20 text-center" :class="props.landingPage ? '' : 'mx-1 sm:mx-2 md:mx-4'">
            <p
                style="
                    font-family: 'Montserrat', sans-serif;
                    font-weight: 600;
                    font-size: 18px;
                    line-height: 21px;
                    letter-spacing: 0.231px;
                    text-transform: uppercase;
                    color: #007fff;
                "
            >
                So funktioniert's
            </p>
            <p class="mt-2 hidden sm:block" style="font-family: 'Montserrat', sans-serif; font-weight: 600; font-size: 28px; line-height: 36px; color: #ececec">
                Einfach einkaufen, teilnehmen und gewinnen!
            </p>

            <!-- Step-Indicator (Desktop) -->
            <div class="hidden xl:flex items-center justify-center mt-8 mb-2">
                <template v-for="(s, i) in steps" :key="'ind-' + s.title">
                    <div
                        class="w-[50px] h-[50px] rounded-full flex items-center justify-center shrink-0 font-bold text-xl"
                        :style="s.highlight ? 'background:#0071E3;color:#fff;' : 'background:#fff;color:#0071E3;'"
                    >
                        {{ i + 1 }}
                    </div>
                    <div v-if="i < steps.length - 1" class="h-[3px] w-[120px] xl:w-[200px]" :style="s.highlight ? 'background:#0071E3;' : 'background:#D9D9D9;'" />
                </template>
            </div>

            <!-- Karten -->
            <div class="mt-6 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 sm:gap-5">
                <div
                    v-for="(s, i) in steps"
                    :key="s.title"
                    class="flex flex-col items-start rounded-xl w-full transition-all duration-200 transform-gpu xl:hover:scale-[1.01] xl:hover:brightness-110 p-4 sm:p-5"
                    :style="`gap:12px;border-radius:12px;background:rgba(255,255,255,0.1);border:1px solid ${s.highlight ? '#0071E3' : 'rgba(255,255,255,0.2)'};`"
                >
                    <div
                        class="w-[32px] h-[32px] rounded-full flex items-center justify-center text-sm font-bold xl:hidden"
                        :style="s.highlight ? 'background:#0071E3;color:#fff;' : 'background:#fff;color:#0071E3;'"
                    >
                        {{ i + 1 }}
                    </div>
                    <div class="flex flex-col items-center w-full gap-3">
                        <i
                            class="text-[50px] leading-none"
                            style="color: #0071e3"
                            :class="{
                                'fi fi-rr-shopping-cart': s.icon === 'cart',
                                'fi fi-rr-trophy': s.icon === 'trophy',
                                'fi fi-rr-ticket': s.icon === 'ticket'
                            }"
                        ></i>
                        <p
                            class="text-center font-semibold w-full"
                            style="font-family: 'Montserrat', sans-serif; font-size: 18px; line-height: 28px; letter-spacing: -0.144px; color: #ececec"
                        >
                            {{ s.title }}
                        </p>
                    </div>
                    <p class="text-center w-full" style="font-family: 'Montserrat', sans-serif; font-size: 15px; line-height: 140%; font-weight: 400; color: #fff">
                        {{ s.subtitle }}
                    </p>
                </div>
            </div>

            <p class="mt-6 text-xxs text-white">
                <!-- TODO: Eigene WM-Teilnahmebedingungen/Datenschutz-Links eintragen (vorerst Glücksrad-Seiten). -->
                DISCLAIMER: Für das HKCM Gewinnspiel zur WM Aktion 26 gelten folgende
                <router-link to="/verlosung" class="text-[#dcc149] underline">Teilnahmebedingungen</router-link> und
                <router-link to="/verlosungdatenschutz" class="text-[#dcc149] underline">Datenschutzhinweise</router-link>.
            </p>
            <p class="mt-3 text-xxs text-white">
                **Auch Upgrades zählen: Wenn Sie ein bestehendes Produkt auf eine höhere Laufzeit upgraden und der zusätzliche Warenkorbwert mindestens
                {{ formatOrderValue(props.minOrderValue) }} € beträgt, qualifiziert sich auch dieses Upgrade für eine weitere Teilnahme.
            </p>
        </section>
    </div>
</template>

<style scoped>
.prize-img {
    filter: drop-shadow(0 0 18px rgba(59, 130, 246, 0.7));
    transition: filter 0.25s ease;
}
.prize-card:hover .prize-img {
    filter: drop-shadow(0 0 30px rgba(59, 130, 246, 1));
}

.hero-img {
    filter: drop-shadow(0 0 20px rgba(220, 193, 73, 0.5));
}

.sofort-ribbon,
.auslosung-ribbon {
    position: absolute;
    right: -35px;
    top: 17px;
    width: 165px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(30deg);
    transform-origin: center;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 12px;
    line-height: 1;
    letter-spacing: 0.5px;
    text-align: center;
    white-space: nowrap;
    color: #fff;
    z-index: 1;
    padding: 0;
}

.sofort-ribbon {
    background: #007fff;
}
.auslosung-ribbon {
    background: #dcc149;
    color: #007fff;
}

@media (max-width: 640px) {
    .sofort-ribbon,
    .auslosung-ribbon {
        right: -22px;
        top: 10px;
        width: 100px;
        height: 18px;
        font-size: 8px;
        letter-spacing: 0.3px;
    }
}
</style>
